import { render, staticRenderFns } from "./productPricingEditor.vue?vue&type=template&id=bd81f4a6&scoped=true&"
import script from "./productPricingEditor.vue?vue&type=script&lang=js&"
export * from "./productPricingEditor.vue?vue&type=script&lang=js&"
import style0 from "./productPricingEditor.vue?vue&type=style&index=0&id=bd81f4a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd81f4a6",
  null
  
)

export default component.exports